(function(angular){
	'use strict';

	angular
		.module('apiModule')
		.factory('UserFactory', [
			'$q',
			'INVESTMENT_ENTITY_ID',
			'HTTP_STATUS',
			'urlFactory',
			transactionServiceFunction
		]);

	function transactionServiceFunction(
		$q,
		INVESTMENT_ENTITY_ID,
		HTTP_STATUS,
		urlFactory
	) {
		var factory = {
			individual: {
				details: {
					save: saveIndividualDetails
				}
			},
			saveCitizenship: saveCitizenship
		};

		return factory;

		function saveIndividualDetails(payload, form) {
			var deferred = $q.defer();
			var saveAccountDetailsUrl = '/api-secured/investment-entity/' + INVESTMENT_ENTITY_ID + '/individual-account';

			urlFactory.apiPostPromise(saveAccountDetailsUrl, payload)
				.then(function(response) {
					deferred.resolve(response.data);
				})
				.catch(function(response) {
					if(response.status === HTTP_STATUS.FORBIDDEN) {
						urlFactory.redirect('/logout');
					} else {
						urlFactory.handleServerValidation(form, response);
					}
					
					deferred.reject();
				});

			return deferred.promise;
		}

		function saveCitizenship(requestBody, form) {
			var deferred = $q.defer();
			var setCountryUrl = '/api-secured/user/set-country';
			urlFactory.apiPostPromise(setCountryUrl, requestBody)
				.then(function () {
					deferred.resolve();
				})
				.catch(function (response) {
					urlFactory.handleServerValidation(form, response);
					deferred.reject();
				});

			return deferred.promise;
		}
	}
})(window.angular);